import React from "react";
import { createPortal } from "react-dom";

const Backdrop = ({ open, onClick, className = "", children }) => {
  if (!open) return null;

  return createPortal(
    <div
      onClick={onClick}
      className={`fixed inset-0 z-[1300] flex items-center justify-center bg-black/50 ${className}`}
    >
      {children}
    </div>,
    document.body
  );
};

export default Backdrop;
